/**
 * @module support/shared/widgets / currency formating directive
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

import { Directive, Input, OnInit, ElementRef, OnChanges } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Directive({
  selector: '[tmoCurrencyFormatter]',
  providers: [CurrencyPipe],
})
export class CurrencyDirective implements OnInit, OnChanges {
  @Input() private currencyCode?: string;
  @Input() private symbolDisplay?: string;
  private value: string = '0';

  @Input() set currencyValue(value: string) {
    this.value = value ? value : '0';
  }

  constructor(
    private currencyPipe: CurrencyPipe,
    private el: ElementRef
  ) {
    this.el = el;
  }

  /**
   * Initializes the data for currency directive.
   * @returns void
   */
  public ngOnInit(): void {
    this.currencyFormatter();
  }

  /**
   * Formats the curency on change
   * @returns void
   */
  public ngOnChanges(): void {
    this.currencyFormatter();
  }

  /**
   * Format the currency in desired format
   * @returns void
   */
  private currencyFormatter(): void {
    const currencyValue = this.currencyPipe.transform(
      this.value,
      this.currencyCode,
      this.symbolDisplay,
      '.2-2'
    );
    this.el.nativeElement.innerText = currencyValue;
  }
}
